import React, { useContext } from 'react';
import './NeedHelpPage.scss';
import { Link, useNavigate } from 'react-router-dom';
import { PageAbsolutePath } from '../../../consts/Common';
import { SiteContext } from '../../../context/SiteContext';
import Links from '../../common/Widgets/Links';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import YourDetails from './YourDetailsPage';
import { ButtonBack } from '../../common/Button/ButtonBack';

const ServiceExcessPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { site } = useContext(SiteContext);
  const { brand } = site;
  const goBack = (): void => {
    navigate(-1);
  };
  const { brandDisplayName, brandPhoneNumbers } = brand;
  const { claimsNumber } = brandPhoneNumbers;

  const chevronLeftComponent = <FontAwesomeIcon icon={faChevronLeft} />;

  return (
    <div>
      <Links
        id='back-link'
        title=''
        items={[{ to: '', text: 'Back', onClick: goBack }]}
        icon={chevronLeftComponent}
      />
      <h2>Your Complimentary Excess Return Voucher</h2>
      <p>
        Claim your Excess Return Voucher to help keep your car 100%{' '}
        {brandDisplayName}. Complete your details below and we&apos;ll send your
        Excess Return voucher by email.
      </p>
      <p>
        Your complimentary one-year Excess Return Voucher works alongside your
        car insurance policy, whoever you&apos;re insured by, and pays back up
        to £200 of your excess costs if you make an accident claim.
      </p>
      <p>
        Just remember to call {brandDisplayName} first{' '}
        <a className='in-text' href={`tel:${claimsNumber}`}>
          {claimsNumber}
        </a>{' '}
        before you call your insurer, and we&apos;ll repair your car using
        manufacturer genuine parts at our approved repairer, provide accident
        recovery if your car isn&apos;t driveable and a free replacement car
        while your car is being repaired.
      </p>
      <p>
        Voucher valid where the repair is carried out by our approved repairer
        on the UK mainland. For full terms and conditions see
        <Link
          id='lnkPolicyDocumentInText'
          className='in-text'
          to={PageAbsolutePath.Insurance.TermsAndConditions}>
          Excess Voucher Terms and Conditions
        </Link>
      </p>
      <p>Offer ends</p>
      <YourDetails pageName='ServiceExcess'></YourDetails>
      <div className='flex-row form-nav'>
        <ButtonBack
          name='btnBack'
          text='Back'
          onClick={goBack}
          additionalClassNames='btn-back'
        />
      </div>
    </div>
  );
};

export default ServiceExcessPage;
